import { html, ref } from "@microsoft/fast-element";
import { FluentButton } from "@fluentui/web-components";
import { startTemplate } from "@microsoft/fast-foundation";
import { telemetry } from "../utilities/telemetry";
// Prevent tree shaking
FluentButton;
export const SearchBoxTemplate = html `
    <template
        tabindex="${x => (x.disabled ? null : 0)}"
        class="
            ${x => (x.readOnly ? "readonly" : "")}
            ${x => (x.isOnImage ? "onimage" : "")}
        "
    >
        <div class="root" part="root">
            ${startTemplate}
            <input
                class="control"
                part="control"
                type="search"
                id="${x => x.id}"
                title="${x => x.title}"
                name="${x => x.name}"
                @input=${x => x.handleTextInput()}
                aria-label="${x => x.title}"
                placeholder=${x => x.placeholder}
                autocomplete=${x => x.autocomplete}
                ?required=${x => x.required}
                ?disabled=${x => x.disabled}
                ?readonly=${x => x.readOnly}
                maxlength="${x => x.maxlength}"
                minlength="${x => x.minlength}"
                ?spellcheck="${x => x.spellcheck}"
                :value="${x => x.value}"
                ${ref("control")}
                ${telemetry(x => x.inputTelemetryTag)}
            />
        </div>
        <div class="searchoptions">
            <slot name="search-options"></slot>
        </div>
        <fluent-button
            title=${x => x.buttonLabel}
            aria-label=${x => x.buttonLabel}
            tabIndex=${x => (x.disabled ? "-1" : "0")}
            appearance="${x => (x.isOnImage ? "stealth" : "accent")}"
            @click="${x => x.submitSearch()}"
            @keypress="${x => x.submitSearch()}"
            ${telemetry(x => x.buttonTelemetryTag)}
        >
            <span part="end" class="end-slot" ${ref("endContainer")}>
                <slot
                    name="end"
                    ${ref("end")}
                    @slotchange=${x => x.handleEndContentChange()}
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="3 3 14 14"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.5 3a5.5 5.5 0 014.23 9.02l4.12 4.13a.5.5 0 01-.63.76l-.07-.06-4.13-4.12A5.5 5.5 0 118.5 3zm0 1a4.5 4.5 0 100 9 4.5 4.5 0 000-9z"
                        />
                    </svg>
                </slot>
            </span>
        </fluent-button>
    </template>
`;
